import { useContentProtection, showProtectionToast } from '.';

interface ContentProtectionProviderProps {
  children: React.ReactNode;
  enabled?: boolean;
  allowList?: string[];
}

export function ContentProtectionProvider({
  children,
  enabled = true,
  allowList = [],
}: ContentProtectionProviderProps) {
  useContentProtection({
    enabled,
    allowList,
    showToast: showProtectionToast,
  });

  return <>{children}</>;
}
